
import uploadData from "../services/uploadData";

const handleUploadMakes = async ({ data }: any) => {
  const uri = `v1/makes/upload`;
  const response = uploadData({ data, uri });
  return response;
};

export {
  handleUploadMakes,
};
